import { render, staticRenderFns } from "./EmailSchedule.vue?vue&type=template&id=88e07a8a&"
import script from "./EmailSchedule.vue?vue&type=script&lang=js&"
export * from "./EmailSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports